import React from 'react';

const SvgMarkerOverRpm = ({ svgRef, title, ...props }) => (
  <svg width="1em" height="1em" viewBox="0 0 30 44" ref={svgRef} {...props}>
    <title>{title}</title>
    <defs>
      <path id="MarkerOverRPM_svg__a" d="M730 471c-8.293 0-15 6.886-15 15.4 0 11.55 15 28.6 15 28.6s15-17.05 15-28.6c0-8.514-6.707-15.4-15-15.4" />
    </defs>
    <use width="100%" height="100%" fill="#ff5d58" xlinkHref="#MarkerOverRPM_svg__a" transform="translate(-715 -471)" />
    <path
      d="M9.81 18.904l-1.82 1.633a9.221 9.221 0 0 1-2.176-5.975c0-5.022 3.973-9.115 8.864-9.115a8.4 8.4 0 0 1 3.207.622l-1.933 1.988a6.447 6.447 0 0 0-1.274-.124c-3.554 0-6.447 2.974-6.447 6.629 0 1.607.556 3.148 1.58 4.342zm7.688-4.515c.055.205.093.417.093.638a2.492 2.492 0 0 1-2.493 2.492 2.492 2.492 0 1 1 0-4.984c.221 0 .433.038.638.093h.001l4.921-4.917a8.593 8.593 0 0 1 1.754 1.769zm5.89-2.906c.343.982.533 2.046.533 3.152 0 2.178-.73 4.272-2.054 5.902l-1.718-1.613c.965-1.18 1.49-2.701 1.49-4.289 0-.402-.03-.786-.098-1.162z"
      fill="#fff"
    />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgMarkerOverRpm svgRef={ref} {...props} />);
export default ForwardRef;



// WEBPACK FOOTER //
// ./src/common/icons/MarkerOverRpm.js